import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrSurveyIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M4.98 6.29C4.98 5.88 5.28 5.59 5.69 5.59H8.52C8.92 5.59 9.23 5.89 9.23 6.29C9.23 6.69 8.93 7 8.52 7H5.69C5.29 7 4.98 6.7 4.98 6.29ZM14 3.55V14.28C14 15.22 13.24 15.99 12.29 15.99H3.71C2.77 15.99 2 15.23 2 14.28V3.55C2 2.61 2.76 1.84 3.71 1.84H4.46C4.72 1.3 5.28 0.92 5.92 0.92H6.07C6.33 0.38 6.89 0 7.53 0H8.45C9.1 0 9.65 0.38 9.91 0.92H10.06C10.71 0.92 11.26 1.3 11.52 1.84H12.29C13.23 1.84 14 2.6 14 3.55ZM5.7 2.55C5.7 2.67 5.8 2.77 5.92 2.77H10.06C10.18 2.77 10.28 2.67 10.28 2.55C10.28 2.43 10.18 2.33 10.06 2.33H5.92C5.8 2.33 5.7 2.43 5.7 2.55ZM12.58 14.29H12.57V3.55C12.57 3.39 12.44 3.25 12.27 3.25H11.51C11.25 3.79 10.69 4.17 10.05 4.17H5.91C5.26 4.17 4.71 3.79 4.45 3.25H3.7C3.54 3.25 3.4 3.38 3.4 3.55V14.29C3.4 14.45 3.53 14.59 3.7 14.59H12.28C12.44 14.59 12.58 14.46 12.58 14.29ZM9.23 8.5C9.23 8.1 8.92 7.8 8.52 7.8H5.69C5.28 7.8 4.98 8.09 4.98 8.5C4.98 8.91 5.29 9.21 5.69 9.21H8.52C8.93 9.21 9.23 8.9 9.23 8.5ZM10.18 10.18L8.52 11.85L8.02 11.34C7.79 11.11 7.41 11.11 7.18 11.34C6.95 11.57 6.95 11.95 7.18 12.18L8.53 13.53L11.03 11.01C11.26 10.78 11.26 10.4 11.03 10.17C10.8 9.94 10.42 9.94 10.19 10.17L10.18 10.18Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrSurveyIconComponent;
